import React from 'react';
import { CustomField } from '../types/custom_field/customField';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface CustomFieldContextProps {
  customFields: Map<string, CustomField>;
  setCustomFields: (fields: Map<string, CustomField>) => void;
  customFieldsLoading: boolean;
}

const defaultContext: CustomFieldContextProps = {
  customFields: new Map(),
  setCustomFields: () => {},
  customFieldsLoading: false,
};

export const CustomFieldContext = React.createContext<CustomFieldContextProps>(defaultContext);

interface CustomFieldState {
  items: Record<string, any>[];
  loading: boolean;
}

export const customFieldSlice = createSlice({
  name: 'customField',
  initialState: { items: [], loading: true } as CustomFieldState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<CustomField[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<CustomField[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
